import { render, staticRenderFns } from "./ClaimDocumentManage.vue?vue&type=template&id=05d896e9&"
import script from "./ClaimDocumentManage.vue?vue&type=script&lang=js&"
export * from "./ClaimDocumentManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports